<script setup lang="ts">
import type { CommandPaletteGroup, CommandPaletteItem } from '@nuxt/ui';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useActiveSystemSpace, useSystemSpaceNavigation } from '#layers/ui-workspace/composables/use-system-space-navigation';
import { BreadcrumbPageSwitcher } from '#layers/ui/public';

interface Props {
	folded?: boolean;
}

const { folded = false } = defineProps<Props>();

const { t } = useI18n();
const { items: systemSpaceItems } = useSystemSpaceNavigation();
const activeSystemSpace = useActiveSystemSpace();

const groups = computed<CommandPaletteGroup<CommandPaletteItem>[]>(() => [{
	id: 'system-spaces',
	label: t('workspace.breadcrumb.system_spaces'),
	items: systemSpaceItems.value.map((item): CommandPaletteItem => ({
		label: t(item.labelKey),
		icon: item.icon,
		active: item.active,
		to: item.to,
	})),
}]);

const label = computed(() => activeSystemSpace.value ? t(activeSystemSpace.value.labelKey) : '');
</script>

<template>
	<BreadcrumbPageSwitcher
		:label
		:groups
		:folded
	/>
</template>
